<template>
  <div
    class="item-boxes--connected"
    :class="{ 'item-boxes--connected--three-columns': threeColumns }"
  >
    <ItemBoxConnected
      v-for="(item, index) in items"
      :key="item.id"
      :link-url="item.linkUrl"
      :image-url="item.imageUrl"
      :brand-name="item.brandName"
      :item-name="item.itemName"
      :item-price="item.itemPrice"
      :is-including-tax="item.isIncludingTax"
      :has-multiple-item-skus="item.hasMultipleItemSkus"
      :price-suffix="priceSuffix"
      :sold-out="item.soldOut"
      :labels="item.labels || []"
      @click-item-box-connected="
        onClickItemBox(item.id, rankOffset + index + 1)
      "
    />
  </div>
</template>
<script>
import ItemBoxConnected from '../../atoms/item_boxes/ItemBoxConnected.vue'
export default {
  components: { ItemBoxConnected },
  props: {
    priceSuffix: {
      type: String,
      default: '~'
    },
    items: {
      type: Array,
      required: true
    },
    // FIXME(item_list_three_columns): ABテスト決着後、不要なら削除する
    threeColumns: {
      type: Boolean,
      required: false,
      default: false
    },
    // 前ページまでの掲載数。click 時の rank（1始まりの通し番号）の算出に使う
    rankOffset: {
      type: Number,
      required: false,
      default: 0
    }
  },
  methods: {
    onClickItemBox(itemId, rank) {
      this.$emit('click-item-boxes-connected', itemId, rank)
    }
  }
}
</script>
<style lang="scss" scoped>
.item-boxes--connected {
  display: grid;
  gap: 2px;
  row-gap: 16px;
  // gapの分をwidthから除くため、 (100% - 2px * gapの数) / columnの数 としている
  grid-template-columns: repeat(6, calc((100% - 2px * 5) / 6));
  @media all and (max-width: $tablet-width) {
    grid-template-columns: repeat(4, calc((100% - 2px * 3) / 4));
  }
  @media all and (max-width: $sp-width) {
    grid-template-columns: repeat(2, calc((100% - 2px) / 2));
  }
  text-align: left;
  justify-content: center;
  max-width: $max-contents-width;
  margin: 0 auto;

  // FIXME(item_list_three_columns): ABテスト決着後、不要なら削除する
  &--three-columns {
    @media all and (max-width: $sp-width) {
      grid-template-columns: repeat(3, calc((100% - 2px * 2) / 3));
    }
    @media all and (max-width: $sp-small-width) {
      grid-template-columns: repeat(2, calc((100% - 2px) / 2));
    }
  }
}
</style>
